import global from "@/locales/hu-HU/global";
import error403 from "@/locales/hu-HU/errors/403";
import error404 from "@/locales/hu-HU/errors/404";
import error500 from "@/locales/hu-HU/errors/500";
import error503 from "@/locales/hu-HU/errors/503";
import error504 from "@/locales/hu-HU/errors/504";
import maintenance from "@/locales/hu-HU/auth/maintenance";
import toast from "@/locales/hu-HU/toast/toast";
import login from "@/locales/hu-HU/auth/login";
import onboarding from "@/locales/hu-HU/auth/onboarding";
import loginPageSteps from "@/locales/hu-HU/loginPageSteps";
import dashboard from "@/locales/hu-HU/dashboard/dashboard";
import account from "@/locales/hu-HU/account/account";
import mailbox from "@/locales/hu-HU/account/mailbox";
import bankstatement from "@/locales/hu-HU/account/bankstatement";
import myApps from "@/locales/hu-HU/my-apps/myApps";
import about from "@/locales/hu-HU/about/about";
import contactService from "@/locales/hu-HU/about/contactService";
import salesPromotions from "@/locales/hu-HU/sales/promotions";
import brochures from "@/locales/hu-HU/sales/brochures";
import shop from "@/locales/hu-HU/shop/data";
import priceList from "@/locales/hu-HU/shop/priceList";
import staff from "@/locales/hu-HU/dashboard/staff";
import promotions from "@/locales/hu-HU/promotions";
import points from "@/locales/hu-HU/points";
import trainings from "@/locales/hu-HU/trainings/trainings";
import vouchers from "@/locales/hu-HU/vouchers/vouchers";
import media from "@/locales/hu-HU/media/index";
import product from "@/locales/hu-HU/product/index";
import message from "@/locales/hu-HU/message/index";
import commitmentLetter from "@/locales/hu-HU/account/commitmentLetter";
import multiplicator from "@/locales/hu-HU/multiplicator";
import widgets from "@/locales/hu-HU/widgets/widgets";
import consents from "@/locales/hu-HU/consents/consents";
import investment from "@/locales/hu-HU/investment/data";
import kickback from "@/locales/hu-HU/kickback";
import portalHome from "@/locales/hu-HU/portal-home/portalHome";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  portalHome: portalHome.messages,
  productBrochures: {
    BDriveTitle: "Termékképek",
    BDriveLinkText: "Link a TERMÉKKÉPEK portálhoz",
  },
}

export default {
  locale: "hu-HU",
  messages,
};
